import type { ThemePreference } from './theme'
import { nextPreference } from './theme'
import { useTheme } from './useTheme'

const PREFERENCE_LABEL: Record<ThemePreference, string> = {
  light: 'Chiaro',
  dark: 'Scuro',
  system: 'Sistema',
}

const PREFERENCE_GLYPH: Record<ThemePreference, string> = {
  light: '☀',
  dark: '☾',
  system: '◐',
}

/**
 * Passa fra chiaro, scuro e sistema con un clic.
 *
 * Un solo controllo che cicla, non tre pulsanti: nella topbar lo spazio è
 * poco e la scelta più frequente — tornare al sistema — resta a un clic da
 * qualunque stato si parta. L'etichetta dice sempre lo stato attuale, mai
 * l'azione: chi legge "Scuro" sa cosa vede adesso, non cosa succederà dopo.
 */
export function ThemeToggle() {
  const { preference, effective, setPreference } = useTheme()

  return (
    <button
      type="button"
      onClick={() => setPreference(nextPreference(preference))}
      aria-label={`Tema: ${PREFERENCE_LABEL[preference]}${preference === 'system' ? ` (adesso ${effective === 'light' ? 'chiaro' : 'scuro'})` : ''}. Clicca per cambiare.`}
      title={`Tema: ${PREFERENCE_LABEL[preference]}`}
      className="text-thread-400 hover:bg-ink-700 hover:text-linen-200 flex h-9 items-center gap-1.5 rounded-md px-2.5 text-base transition-colors duration-[var(--dur-fast)]"
    >
      <span aria-hidden="true">{PREFERENCE_GLYPH[preference]}</span>
      <span className="type-data hidden sm:inline">{PREFERENCE_LABEL[preference]}</span>
    </button>
  )
}
